module.exports = __webpack_public_path__ + "img/giza.4fdb44ed.png";